import "core-js/modules/es7.object.get-own-property-descriptors.js";
import "core-js/modules/es6.symbol.js";
import "core-js/modules/web.dom.iterable.js";
import "core-js/modules/es6.object.to-string.js";
import "core-js/modules/es6.object.keys.js";
import "regenerator-runtime/runtime.js";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import "core-js/modules/es6.array.find.js";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import '~/node_modules/@web/shared-digital-library/icons/svg-originals/infobulle.svg';
import '~/node_modules/@web/shared-digital-library/icons/svg-originals/geoloc.svg';
import { mapGetters } from 'vuex';
import USE_MERCURE from '~/const/mercure';
import { FAQ } from '~/const/faq';
import navigationQuery from '~/graphql/navigation.gql';
import Banner from '~/components/specific/MainHeader/Banner.vue';
import BannerMobile from '~/components/specific/MainHeader/BannerMobile.vue';
import NavigationBar from '~/components/specific/MainHeader/NavigationBar.vue';
import LayerMobile from '~/components/specific/MainHeader/LayerMobile.vue';
import LayerFullscreenHeader from '~/components/specific/MainHeader/LayerFullscreenHeader.vue';
import focusElement from '~/helpers/a11y-helpers';

var LayerDesktop = function LayerDesktop() {
  return import(
  /* webpackChunkName: "layer-desktop" */
  './LayerDesktop.vue');
};

export default {
  name: 'MainHeader',
  components: {
    Banner: Banner,
    BannerMobile: BannerMobile,
    NavigationBar: NavigationBar,
    LayerFullscreenHeader: LayerFullscreenHeader,
    LayerMobile: LayerMobile,
    LayerDesktop: LayerDesktop
  },
  data: function data() {
    return {
      navigation: [],
      navigationServices: [],
      isMenuOpened: '',
      selectedItem: null,
      scrollPosition: 0,
      displayNavBar: false,
      enableNavTransition: false,
      lastActiveElement: null,
      stickyFilters: null
    };
  },
  computed: _objectSpread(_objectSpread({}, mapGetters({
    locale: 'i18n/locale',
    homeUrl: 'i18n/homeUrl',
    user: 'user/me'
  })), {}, {
    bodyClasses: function bodyClasses() {
      return this.isMenuOpened ? 'no-scroll w-100' : '';
    },
    accountUrl: function accountUrl() {
      if (this.user && USE_MERCURE(this.locale.iso)) {
        return "".concat(this.homeUrl, "/user");
      }

      if (USE_MERCURE(this.locale.iso)) {
        return "".concat(this.homeUrl, "/login");
      }

      return "".concat(this.homeUrl, "/account/dashboard");
    },
    faqUrl: function faqUrl() {
      var _this = this;

      // if (USE_MERCURE(this.locale.iso)) {
      //   return `/${this.locale.market}/${this.locale.language}/help`;
      // }
      return FAQ.find(function (e) {
        return e.language === _this.locale.iso;
      }).url;
    },
    urls: function urls() {
      return {
        cartUrl: this.buildCartUrl(this.locale),
        homeUrl: this.homeUrl,
        storeLocUrl: "".concat(this.homeUrl, "/store-locator"),
        helpUrl: this.faqUrl,
        accountUrl: this.accountUrl
      };
    }
  }),
  apollo: {
    navigation: {
      query: navigationQuery,
      variables: function variables() {
        return {
          locale: this.locale.iso
        };
      }
    },
    navigationServices: {
      query: navigationQuery,
      variables: function variables() {
        return {
          locale: this.locale.iso
        };
      }
    }
  },
  mounted: function mounted() {
    var _this2 = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var draftId, _yield$_this2$$apollo, _yield$_this2$$apollo2, navigation, navigationServices;

      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              draftId = _this2.$cookies.get('NAVIGATION_PREVIEW');

              if (!draftId) {
                _context.next = 17;
                break;
              }

              if (_this2.$cookies.get('debugmdm')) _this2.$logger.debug('Previewing draft', draftId);
              _context.prev = 3;
              _context.next = 6;
              return _this2.$apolloProvider.defaultClient.query({
                query: navigationQuery,
                variables: {
                  locale: _this2.locale.iso,
                  draftId: draftId
                }
              });

            case 6:
              _yield$_this2$$apollo = _context.sent;
              _yield$_this2$$apollo2 = _yield$_this2$$apollo.data;
              navigation = _yield$_this2$$apollo2.navigation;
              navigationServices = _yield$_this2$$apollo2.navigationServices;
              _this2.navigation = navigation;
              _this2.navigationServices = navigationServices;
              _context.next = 17;
              break;

            case 14:
              _context.prev = 14;
              _context.t0 = _context["catch"](3);

              _this2.$logger.error(_context.t0);

            case 17:
              document.addEventListener('click', _this2.onClickOutside);
              window.addEventListener('scroll', _this2.handleScroll, {
                passive: true
              });
              _this2.scrollPosition = window.pageYOffset;
              _this2.displayNavBar = !_this2.isMobile();

              _this2.$nextTick(function () {
                _this2.enableNavTransition = true;
              });

            case 22:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[3, 14]]);
    }))();
  },
  destroyed: function destroyed() {
    document.removeEventListener('click', this.onClickOutside);
    window.removeEventListener('scroll', this.handleScroll);
  },
  methods: {
    openMenu: function openMenu(items) {
      var _this3 = this;

      this.selectedItem = items;

      if (items === 'mobile') {
        this.isMenuOpened = 'mobile';
      } else {
        this.isMenuOpened = items && this.isMenuOpened !== items.label ? items.label : '';
        this.lastActiveElement = document.activeElement;
        this.$nextTick(function () {
          return focusElement(_this3.$refs.layerFullscreen.$refs.close.$el);
        });
      }
    },
    closeMenu: function closeMenu() {
      this.isMenuOpened = '';
      this.selectedItem = null;
      this.$refs.layerMobile.close();
    },
    handleScroll: function handleScroll() {
      if (this.isMobile()) {
        this.displayNavBar = false;
        return;
      }

      var scroll = window.pageYOffset;
      this.displayNavBar = this.scrollPosition > scroll || scroll <= 1;
      this.scrollPosition = scroll;
    },
    onClickOutside: function onClickOutside(event) {
      var _this$$refs = this.$refs,
          navigationBar = _this$$refs.navigationBar,
          layerFullscreen = _this$$refs.layerFullscreen,
          bannerMobile = _this$$refs.bannerMobile,
          layerMobile = _this$$refs.layerMobile;
      if (!navigationBar || navigationBar.$el.contains(event.target) || !layerFullscreen || layerFullscreen.$el.contains(event.target) || !bannerMobile || bannerMobile.$el.contains(event.target) || !layerMobile || layerMobile.$el.contains(event.target)) return;
      this.closeMenu();
    }
  },
  head: function head() {
    return {
      bodyAttrs: {
        class: this.bodyClasses
      }
    };
  }
};